<div class="container">
  <div class="material-icons {{data.icon_class}} icon">{{data.icon}}</div>
  <div class="message_container">
    <div style="flex: 1 1 auto; margin: auto auto">{{data.message}}</div>
    <button *ngIf="data.actionTitle != null && data.actionTitle.length > 0" style="flex: 1 0 auto; height: 34px; margin: auto 0 auto 1em;" mat-stroked-button color="primary" (click)="actionClicked()">{{data.actionTitle}}</button>
  </div>
</div>
